module.exports = __webpack_public_path__ + "static/media/login-cards.16f203d1.png";